import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import "@/App.css";

import PublicLayout from "@/pages/public/PublicLayout";
import Home from "@/pages/public/Home";
import ArticleList from "@/pages/public/ArticleList";
import ArticleDetail from "@/pages/public/ArticleDetail";
import CategoriesPage from "@/pages/public/CategoriesPage";
import CategoryPage from "@/pages/public/CategoryPage";
import AuthorPage from "@/pages/public/AuthorPage";
import MagazinesPage from "@/pages/public/MagazinesPage";
import AboutPage from "@/pages/public/AboutPage";
import ContactPage from "@/pages/public/ContactPage";
import NotFound from "@/pages/public/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ArticlesAdmin from "@/pages/admin/ArticlesAdmin";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import CategoriesAdmin from "@/pages/admin/CategoriesAdmin";
import AuthorsAdmin from "@/pages/admin/AuthorsAdmin";
import MagazinesAdmin from "@/pages/admin/MagazinesAdmin";
import SubscribersAdmin from "@/pages/admin/SubscribersAdmin";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import AdsAdmin from "@/pages/admin/AdsAdmin";
import HeroAdmin from "@/pages/admin/HeroAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";
import RoleRoute from "@/pages/admin/RoleRoute";
import ArticlePreview from "@/pages/admin/ArticlePreview";
import FeaturedAdmin from "@/pages/admin/FeaturedAdmin";

function ScrollTop() {
  const { pathname } = window.location;
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <Toaster position="bottom-right" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/articulos" element={<ArticleList />} />
                <Route path="/articulo/:slug" element={<ArticleDetail />} />
                <Route path="/categorias" element={<CategoriesPage />} />
                <Route path="/categoria/:slug" element={<CategoryPage />} />
                <Route path="/autor/:id" element={<AuthorPage />} />
                <Route path="/revistas" element={<MagazinesPage />} />
                <Route path="/nosotros" element={<AboutPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/preview/:id" element={<ArticlePreview />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="articulos" element={<ArticlesAdmin />} />
                <Route path="articulos/nuevo" element={<ArticleEditor />} />
                <Route path="articulos/:id" element={<ArticleEditor />} />
                <Route path="destacados" element={<RoleRoute roles={["super_admin", "editor"]}><FeaturedAdmin /></RoleRoute>} />
                <Route path="categorias" element={<RoleRoute roles={["super_admin", "editor"]}><CategoriesAdmin /></RoleRoute>} />
                <Route path="autores" element={<RoleRoute roles={["super_admin", "editor"]}><AuthorsAdmin /></RoleRoute>} />
                <Route path="revistas" element={<RoleRoute roles={["super_admin", "editor"]}><MagazinesAdmin /></RoleRoute>} />
                <Route path="suscriptores" element={<RoleRoute roles={["super_admin", "editor"]}><SubscribersAdmin /></RoleRoute>} />
                <Route path="media" element={<MediaAdmin />} />
                <Route path="anuncios" element={<RoleRoute roles={["super_admin", "editor"]}><AdsAdmin /></RoleRoute>} />
                <Route path="hero" element={<RoleRoute roles={["super_admin", "editor"]}><HeroAdmin /></RoleRoute>} />
                <Route path="configuracion" element={<RoleRoute roles={["super_admin", "editor"]}><SettingsAdmin /></RoleRoute>} />
                <Route path="usuarios" element={<RoleRoute roles={["super_admin"]}><UsersAdmin /></RoleRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
